import { AppBar, Toolbar, Stack, Button, Typography, Menu, MenuItem } from '@mui/material';
import {
  // Dispatch, SetStateAction,
  useState,
} from 'react';
import { useRecoilValue } from 'recoil';
import * as all from '../util/all';

import { Tour, TourType } from '@/_models/Tour';
import DeviceManager from '../util/deviceManager';
import { navigationSettingsState } from '../../store';
import { trimDescription as trimText } from '@/components/navigation/search-bar/util';

import EnSvgIcon, { EngIconMobile } from '@/components/navigation/icons/Icons';

type HeaderProps = {
  rtl: boolean;
  isBackgroundVisible: boolean;
  tour: Tour;
  tourType: TourType;
  // target: any;
  // kioskIsReset: boolean;
  // categories: any[];
  // setSearchText: Dispatch<SetStateAction<string>>;
  // selectCategory: (category: any) => void;
  // setIsSearchBarFocused: Dispatch<SetStateAction<boolean>>;
  // setBackgroundVisible: (val: boolean) => void;
  mobilePosition: number;
};

export const NavigationHeader = ({
  rtl,
  isBackgroundVisible,
  tour,
  tourType,
  // target,
  // kioskIsReset,
  // categories,
  // setSearchText,
  // selectCategory,
  // setIsSearchBarFocused,
  // setBackgroundVisible,
  mobilePosition,
}: HeaderProps) => {
  const navigationSettings = useRecoilValue(navigationSettingsState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="static"
      sx={{
        background: { xs: 'transparent', sm: isBackgroundVisible ? '#fff' : 'transparent' },
        borderBottom: { xs: 'none', sm: isBackgroundVisible ? '1px solid #D0D5DD' : 'none' },
        height: { xs: '63px', lg: '70px' },
        boxShadow: 'none',
        visibility: !isBackgroundVisible && tourType === TourType.Regular ? 'hidden' : 'visible',
        filter: { xs: mobilePosition > 1 ? 'blur(3px)' : 'none', sm: 'none' },
      }}
    >
      <Toolbar
        sx={{
          width: '100%',
          height: 'inherit',
          p: { xs: '10px 14px', lg: '15px 20px' },
          display: 'flex',
          justifyContent: { xs: 'center', lg: 'space-between' },
          position: 'relative',
        }}
      >
        <Stack>
          {tour.client && tour.client.logo && (
            <img
              width={DeviceManager.isMobile() ? '99px' : '133px'}
              height={DeviceManager.isMobile() ? '34px' : '46px'}
              style={{ objectFit: 'contain' }}
              src={`${process.env.REACT_APP_AWS}/clients/${tour.client.id}/logo.png${all.getVersion(tour.client.updatedAt)}`}
              alt=""
            />
          )}
        </Stack>

        <Stack sx={{ display: { xs: 'none', sm: 'flex' } }}>
          <Typography fontSize="20px" mx="auto" fontWeight={{ xs: 500, lg: 600 }} textAlign="center" color="black" sx={{ direction: rtl ? 'rtl' : 'ltr' }}>
            {navigationSettings?.titleEnabled && navigationSettings?.title ? trimText(navigationSettings?.title, 60) : ''}
          </Typography>
        </Stack>

        {/* {!!isBackgroundVisible && DeviceManager.isMobile() && (
          <Stack width="100%" direction="row" alignItems="flex-start" justifyContent="space-between" position="absolute" p="10px 14px">
            {!!target && !kioskIsReset && (
              <Button
                disableElevation
                sx={{
                  minWidth: 'unset',
                  width: '44px',
                  height: '44px',
                  background: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #EAECF0',
                  '&:hover': {
                    background: '#fff',
                  },
                }}
                variant="contained"
                onClick={() => {
                  setSearchText('');
                  if (categories?.length > 1) selectCategory(null);
                  setIsSearchBarFocused(true);
                }}
              >
                <i
                  className="fa-solid fa-bars"
                  style={{
                    color: '#000',
                    fontSize: '24px',
                    fontWeight: 500,
                  }}
                />
              </Button>
            )}

            {!!target && !kioskIsReset && (
              <Button
                disableElevation
                sx={{
                  minWidth: 'unset',
                  width: '44px',
                  height: '44px',
                  background: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #EAECF0',
                  '&:hover': {
                    background: '#fff',
                  },
                }}
                variant="contained"
                onClick={() => setBackgroundVisible(false)}
              >
                <i
                  className="fa-solid fa-xmark"
                  style={{
                    color: '#000',
                    fontSize: '24px',
                    fontWeight: 500,
                  }}
                />
              </Button>
            )}
          </Stack>
        )} */}
        {/* LANGUAGE MEN HIDDEN FOR NOW */}
        <Button
          id="lang-button"
          aria-controls={open ? 'lang-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant={!DeviceManager.isMobile() ? 'contained' : 'text'}
          disableElevation
          onClick={handleClick}
          startIcon={DeviceManager.isMobile() ? EngIconMobile : <EnSvgIcon width={24} height={15} />}
          endIcon={!DeviceManager.isMobile() ? <i className="fa-solid fa-chevron-down" style={{ fontSize: '12px', fontWeight: 600 }} /> : undefined}
          sx={{
            // TODO remove visibility: hidden when full language change feature is developed
            visibility: 'hidden',
            direction: rtl ? 'rtl' : 'ltr',
            gap: '8px',
            marginLeft: { xs: 'auto', sm: 'unset' },
            minWidth: { xs: '36px', sm: '64px' },
            width: { xs: '36px', sm: '130px' },
            height: { xs: '36px', sm: '47px' },
            borderRadius: '8px',
            border: { xs: 'none', sm: '1px solid #D0D5DD' },
            background: { xs: 'transparent', sm: '#FFF' },
            padding: '7px 12px',
            color: '#000',
            '&:hover': {
              background: { xs: 'transparent', sm: '#FFF' },
              color: '#000',
            },
            '&:focus': {
              border: { xs: 'none', sm: '1px solid #D0D5DD' },
            },
            '.MuiButton-endIcon': {
              marginRight: '0',
              marginLeft: '0',
              width: '38px',
              height: 'inherit',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
            '.MuiButton-startIcon': {
              mx: '0px',
              width: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          }}
        >
          <Typography sx={{ fontSize: '14px', fontWeight: 600, display: { xs: 'none', sm: 'block' } }}>English</Typography>
        </Button>
        <Menu
          elevation={0}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          id="lang-menu"
          MenuListProps={{
            'aria-labelledby': 'lang-button',
            sx: { background: '#fff' },
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose} disableRipple>
            Spanish
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
